<div class="friendlyName">
  <h3>
    {{
      "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.DISPLAY_NAME.TITLE"
        | translate
    }}
  </h3>
  <!-- will render the form -->
  <dynamic-form
  [fields]="form.friendlyName.fields"
  [options]="form.friendlyName.formOptions"
  [isSubmitted]="isSubmitBtnClicked"
  [refreshEnabled]="true"
  (onSubmit)="_saveFriendlyName($event)"
></dynamic-form>
<!-- form ends -->
  <div class="btn-group">
    <ng-container *ngTemplateOutlet="btnGroup"></ng-container>
  </div>
</div>

<ng-template #btnGroup>
  <div class="btn-wrapper">
    <div class="btngroup">
      <cid-button
        [btnOption]="form.friendlyName.buttons.cancel"
        (clickEvent)="_skipFriendlyName()"
      ></cid-button>
      <cid-button
        [btnOption]="form.friendlyName.buttons.submit"
      ></cid-button>
    </div>
  </div>
</ng-template>
